import { create } from "zustand";

interface ConfirmOptions {
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  isDestructive?: boolean;
}

interface ConfirmState {
  isOpen: boolean;
  options: ConfirmOptions;
  resolve: (value: boolean) => void;
  confirm: (options?: ConfirmOptions) => Promise<boolean>;
  close: () => void;
}

export const useConfirm = create<ConfirmState>((set, get) => ({
  isOpen: false,
  options: {
    title: "Emin misiniz?",
    description: "Bu işlemi onaylıyor musunuz?",
    confirmText: "Onayla",
    cancelText: "Vazgeç",
    isDestructive: false,
  },
  resolve: () => {},
  confirm: (options) => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        options: { ...get().options, ...options },
        resolve,
      });
    });
  },
  close: () => {
    const { resolve } = get();
    resolve(false);
    set({ isOpen: false });
  },
}));
